module.exports = __webpack_public_path__ + "img/team_leader_5.184a3b86.png";